


import { initAttentionScopes } from './macros/ani-attention-scopes.js';
import { prepareCountingStatementsAni } from './macros/counting-statements-ani.js';
import { initParallaxAni } from './macros/ani-parallax.js';
import { initAniOverlay } from './macros/ani-overlays.js';
import { initAniSplitStagger } from './macros/ani-split-stagger.js';
import { initTiltpara } from './macros/ani-tiltpara.js';
import { initBorderRunner } from './macros/ani-border-runner.js';
import { initAniLightflow, initAniLightbulb } from './macros/ani-light.js';
import { initLiquidEtherDominant } from './macros/ani-liquid-dominant.js';





export function initAniMacros() {
  
  initAttentionScopes(),
  prepareCountingStatementsAni(),
  initParallaxAni();
  initAniOverlay();
  initAniSplitStagger();
  initTiltpara();
  initBorderRunner();
  initAniLightbulb();
  initAniLightflow();
  
  
  initLiquidEtherDominant();

}




